type Cue = 'save.success' | 'error.soft' | 'reveal.done' | 'stamp.collect';
const files: Record<Cue, string> = {
  'save.success': '/audio/save.success.wav',
  'error.soft': '/audio/error.soft.wav',
  'reveal.done': '/audio/reveal.done.wav',
  'stamp.collect': '/audio/stamp.collect.wav',
};
const lastPlayed = new Map<Cue, number>();

export function soundMuted() {
  return window.localStorage.getItem('juice.muted') === 'true';
}

export function setSoundMuted(muted: boolean) {
  window.localStorage.setItem('juice.muted', String(muted));
}

export function playCue(cue: Cue) {
  if (soundMuted()) return;
  const now = performance.now();
  const cooldown = cue === 'error.soft' ? 500 : 150;
  if (now - (lastPlayed.get(cue) ?? -Infinity) < cooldown) return;
  lastPlayed.set(cue, now);
  const audio = new Audio(files[cue]);
  audio.volume = cue === 'save.success' ? 0.4 : 0.45;
  void audio.play().catch(() => undefined);
}
